import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description ThumbDown icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { ThumbDown } from '@sravni/design-system-icons'
 *
 * <ThumbDown />
 * ```
 */
var ThumbDown = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "ThumbDown", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M3 12.325V3.472M9.649 16.322 6 11.571V5.043l1.232-1.326a1.8 1.8 0 0 1 1.318-.574h6.289a1.8 1.8 0 0 1 1.729 1.302l1.359 4.722a1.8 1.8 0 0 1-.234 1.499l-.329.491a1.8 1.8 0 0 1-1.496.799h-3.096v3.271c0 .416-.144.82-.409 1.141a1.734 1.734 0 0 1-2.714-.046Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { ThumbDown };
//# sourceMappingURL=ThumbDown.js.map
